// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LAk6","delete":"styles_delete__3v8Pk","update":"styles_update__1kMpH","add":"styles_add__3vHwE"};